module.exports = __webpack_public_path__ + "media/images/static/top/local/photo2-2222a48fe62696487f42bed3f3343909.png";